export default __webpack_public_path__ + "static/media/attchment-cv.98acf55f.svg";